/// <reference path="../../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class MapConfigurationPreviewModel {
        public mapConfiguration: Wars.Domain.Model.Gis.MapConfiguration;
        public mapId: string="PreviewMap";

        constructor(mapConfigurationService: services.MapConfigurationService,
                    private gisMapService: services.GisMapService, mapConfigurationId: string) {
            mapConfigurationService.getMapConfiguration(mapConfigurationId).then(m => {
                this.mapConfiguration = m;
            });
        }

        public runWorkflow(workflow: Wars.Domain.Model.Gis.GisActionWorkflowConfiguration) {
            this.gisMapService.runWorkflow(workflow,services.UtilityService.generateGuidComb(),
                services.UtilityService.generateGuidComb());
        }
    }
}

